export default __webpack_public_path__ + "static/media/pf_logo_oficial.fc4ab1c8.jpg";